<ngx-skeleton-loader
  [theme]="{
    height: '30px',
  }"
/>
<ngx-skeleton-loader
  [theme]="{
    height: '30px',
    width: '80%',
  }"
/>
<div class="row">
  @for (item of [].constructor(8); track $index) {
    <div class="col-3">
      <ngx-skeleton-loader
        [theme]="{
          height: '170px',
          borderRadius: '20px',
        }"
      />
    </div>
  }
</div>
